module.exports = __webpack_public_path__ + "img/9788952232878.2fbfe66d.jpg";